<template>
    <section class="faq-section">
      <h2>Frequently Asked Questions</h2>
      <div class="faq-item" v-for="(item, index) in faqs" :key="index">
        <button class="faq-question" @click="toggleAnswer(index)">
          {{ item.question }} <span :class="{'active': item.open}"></span>
        </button>
        <div class="faq-answer" :class="{ 'open': item.open }">
          <p v-html="item.answer"></p>
        </div>
      </div>
      <p class="legend">Check out our <a href="/pages/faq">Help Center</a> for more FAQs</p>
    </section>
  </template>
  
  <script>
  export default {
    name: 'FaqSection',
    data() {
      return {
        faqs: [
          {
            question: "How can I track who claimed their Gift of Choice gift?",
            answer: `Tracking the recipient activity of a Gift of Choice gift is easy! You’ll want to <a href="https://happyboxstore.com/account">login (or signup if you have not already) to your Happy Box account</a> and navigate to the “<a href="https://happyboxstore.com/pages/gift-activity?show=account">Gift of Choice Activity</a>” page. There, you can look at all the data from Gift of Choice gifts you sent, as well as individual recipient data. Scroll down to the table and you can see if your recipient has claimed their gift, what they claimed, and their tracking number once it ships.`,
            open: false
          },
          {
            question: "Can I send a Gift of Choice gift without a physical address?",
            answer: `Yes! That is actually the only way the Gift of Choiceexperience works. You’ll send the Gift of Choice gift to your recipient’s email, and they will enter their own address information after they select their gift.`,
            open: false
          },
          {
            question: "How do I send bulk gifts in Gift of Choice?",
            answer: `Sending bulk gifts with our Gift of Choice collections is easy! Once you select the collection you’d like to send, you’ll be prompted to enter you recipient info. You’ll need to adjust the number of recipients you’d like to send to, and then you can upload our bulk template to send to many recipients at one time.`,
            open: false
          },
          {
            question: "What happens if my recipient does not claim their gift?",
            answer: `The gift purchaser has 60 days from expiration date of the gift to convert the Gift of Choice credit to happyboxstore.com store credit. To do so, email <a href='mailto:orders@happyboxstore.com'>orders@happyboxstore.com</a> with your order number. After that 60 days, the gift credit will be considered abandoned and no longer able to be redeemed. `,
            open: false
          },
          {
            question: "How long will it take my Gift of Choice recipient to get their gift delivered?",
            answer: `Once they have claimed their gift (which can take up to 4 weeks from your gift alert date), it can take 1-3 weeks approximately to receive their gift, as we order some product from external partners to be able to offer the breadth of gifts we have on our site. For questions on an order status please email <a href='mailto:orders@happyboxstore.com'>orders@happyboxstore.com</a>.`,
            open: false
          }
        ]
      };
    },
    methods: {
      toggleAnswer(index) {
        this.faqs.forEach((faq, i) => {
          if (i === index) {
            faq.open = !faq.open;
          } else {
            faq.open = false;
          }
        });
      }
    }
  };
  </script>
  <style>
  .faq-section a{
		color: #A01ADB;
		text-decoration: underline;
		font-weight: bold;
	}
  </style>
  <style scoped>
  .faq-section {
    padding: 5% 10%;
    margin: 0 auto;
    border-radius: 10px;
  }
  
  .faq-answer a {
    color: #A01ADB;
    text-decoration: underline;
    font-weight: bold;
  }
  
  .faq-section .legend {
    margin-top: 5%;
    text-align: center;
  }
  
  .faq-section h2 {
    margin-bottom: 2%;
    font-size: 4vw;
    line-height: 1;
    font-family: "ff-more-web-pro-condensed", "Karla", sans-serif;
    font-weight: 300;
    text-align: center;
  }
  
  .faq-item {
    border-bottom: 1px solid #e0e7ff;
    padding: 15px 0;
  }
  
  .faq-item:last-child {
    border-bottom: none;
  }
  
  .faq-question {
    background: none;
    border: none;
    width: 100%;
    text-align: left;
    font-size: 1.5vw;
    cursor: pointer;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    color: #0f0c38;
  }
  
  .faq-question span {
    transition: transform 0.3s;
    border: solid black;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 5px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }
  
  .faq-question.active span {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
  }
  
  .faq-answer {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.5s ease-out;
    padding: 0 10px;
    font-size: 1em;
    line-height: 1.5em;
  }
  
  .faq-answer.open {
    max-height: 200px; /* Adjust this value based on the content length */
    transition: max-height 0.5s ease-in;
  }

  @media screen and (max-width: 767px) {
    .faq-question{
			font-size: 4vw;
			width: 100%;
		}

    .faq-section h2{
			font-size: 8vw;
			padding: 0% 5%;
		}

    .faq-answer.open{
			max-height: 400px;
		}

    .faq-section {
      padding: 5%;
    }
  }
  </style>
  